import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const bindPromotersOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "推广员姓名",
            prop: "name",
            type: 'input',
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        }, 
        {
            label: "推广员账号",
            prop: "findName",
            type: 'select',
            formsolt:true,
            hide:true,
        },
        {
            label: "推广员账号",
            prop: "account",
            type: 'input',
            search:true,
            addVisdiplay: false,
            editVisdiplay: false
        }, 
        {
            label: "性别",
            prop: "sex",
            type: 'select',
            dicData: DIC.SEX,
            addVisdiplay: false,
            editVisdiplay: false
        },
       
        {
            label: "绑定时间",
            prop: "bindingTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "bindingType",
            type: "input",
            hide:true,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};